import type { PointBounds } from "./MapPointQuery";

export const containsPointBounds = (area: PointBounds, viewport: PointBounds): boolean =>
  area[0] <= viewport[0] && area[1] <= viewport[1] && area[2] >= viewport[2] && area[3] >= viewport[3];

// Draw beyond the viewport to keep nearby markers ready during camera movement.
export const bufferPointBounds = (bounds: PointBounds, padding = 0.5): PointBounds => {
  const longitudePadding = (bounds[2] - bounds[0]) * padding;
  const latitudePadding = (bounds[3] - bounds[1]) * padding;
  return [
    Math.max(-180, bounds[0] - longitudePadding),
    Math.max(-90, bounds[1] - latitudePadding),
    Math.min(180, bounds[2] + longitudePadding),
    Math.min(90, bounds[3] + latitudePadding),
  ];
};
